<template>
  <v-card width="1000" class="mx-auto mt-12">
    <v-card-text>
      <v-card flat class="mx-auto" width="125">
        <v-row justify="center">
          <v-img
            align="center"
            justify="center"
            :src="require(`@/assets/${$store.getters.getLogo.path}/logo.png`)"
            class="mb-8 mt-10 sentinel-logo--style"
          />
        </v-row>
      </v-card>

      <v-card-text class="mt-6">
        {{
          $t(
            "consents.termsOfService.asTheMostTrustedBoatMonitoringAndFleetManagementPlatformProtectPersonalDataAndComplyWithTheEUsGeneralDataRegulationGDPRToUseThisPlatformPleaseMakeSureYouHaveAndUnderstoodOur"
          )
        }}

        <a :href="getLinks.privacyPolicy" target="_blank">{{
          $t("consents.termsOfService.privacyPolicy")
        }}</a>
        {{ $t("consents.termsOfService.and") }}
        <a :href="getLinks.termsOfUse" target="_blank">{{
          $t("consents.termsOfService.termsOfUse")
        }}</a
        >.
      </v-card-text>
      <v-card-text>
        {{
          $t(
            "consents.termsOfService.pleaseMakeSureYouUndertandBothAsTheyMayBeImportantToYou"
          )
        }}
      </v-card-text>
    </v-card-text>

    <v-card-actions>
      <v-btn text @click="handleTosDialogOutput(false)">
        {{ $t("consents.termsOfService.cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleTosDialogOutput(true)">
        {{ $t("consents.termsOfService.agree") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { USER_ACCEPTED_TOS } from "@/store/actions/user";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import restrictions from "@/utils/restrictions";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getMe", "getLinks"]),
  },
  methods: {
    handleTosDialogOutput(agreed) {
      if (agreed) {
        this.$store.dispatch(USER_ACCEPTED_TOS).then((resp) => {
          this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
            const nextRoute = restrictions.nextBaseRoute(resp);
            this.$router.push(nextRoute);
          });
        });
      } else {
        this.$store.dispatch(AUTH_LOGOUT).then(() => {
          this.$router.push({ path: "/login" });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
.responsive--iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.container--iframe {
  position: relative;
  width: 98%;
  padding-top: 50%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}
.link--color {
  color: --primary;
}
</style>
